<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
        <div class="title">{{ $t(`Contacts`) }}</div>
        </div>
      </div>
      <div class="section contact-section">
        <div class="title">{{ $t(`Have a question?`) }}</div>
        <div class="form-fields-wrapper">
          <label>
            <input type="text" :placeholder="$t('Name')" v-model="name"/>
          </label>
          <label>
            <input type="text" :placeholder="$t('Surname')" v-model="surname"/>
          </label>
          <label>
            <input type="email" :placeholder="$t('E-mail address')" v-model="email"/>
          </label>
          <label v-if="countryOptions && countryOptions.length">
            <VuePhoneNumberInput
                required
                v-model="phone"
                :only-countries="countryOptionsIso"
                :default-country-code="defaultCountryIso"
                @update="phoneDataUpdate($event)"
                :translations="phoneInputTranslations"
            />
          </label>
          <label class="full">
            <input type="text" :placeholder="$t('Topic')" v-model="topic"/>
          </label>
          <label class="full">
            <textarea :placeholder="$t('Message')" v-model="message"></textarea>
          </label>
          <button @click="contactSubmit" class="button">
            <span>{{ $t(`Send`) }}</span>
          </button>
          <transition name="fade">
            <div v-if="error" class="error-desc desc red">{{error}}</div>
          </transition>
          <transition name="fade">
            <div v-if="successMessage" class="error-desc desc green">{{successMessage}}</div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent } from 'vue';
import VuePhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import {filterPhoneCountries} from '@/utils/filterPhoneCountries'


export default defineComponent({
  name: 'Contaacts',
  props: [],

  components: {
    VuePhoneNumberInput
  },
  inject: ['openSignInModal'],
  data: function() {
    return {
      successMessage: '',
      error: '',
      name: '',
      surname: '',
      email: '',
      phone: '',
      topic: '',
      message: '',
      countryOptions: [],
      countryOptionsIso: [],
      phoneFull: '',
      phoneInputTranslations: {
        countrySelector: {
          placeholder: 'Country code',
          error: 'Choose country',
          searchPlaceholder: 'Search a country',
        },
        phoneInput: {
          placeholder: '* Phone number',
          example: 'Example:',
        },
      }
    }
  },

  mounted() {
    this.getCountries();
  },

  methods: {
    getCountries() {
      this.$http.get('countries')
          .then(res => {
            const allCountries = res.data.payload

            // Полный список для селекта
            this.countryOptions = allCountries

            // Отфильтрованные ISO коды только для phone input
            this.countryOptionsIso = filterPhoneCountries(allCountries).filtered.map(({iso2}) => iso2)
          })
          .catch(err => {
            if (err.response?.status === 401) {
              this.openSignInModal()
            }
          })
    },
    phoneDataUpdate(e) {
      this.phoneFull = e.formatInternational;
    },
    contactSubmit() {
      let data = {
        "name": this.name,
        "surname": this.surname,
        "email": this.email,
        "phone": this.phoneFull,
        "topic": this.topic,
        "message": this.message
      }
      let self = this;
      this.$http.post( 'contact-us', data)
      .then((res) => {
        if (res.data.status == "OK") {
          self.error = '';
          self.successMessage = 'Thank you!'
          setTimeout(function() {
            self.successMessage = '';
          }, 2000)
        } else {
          this.error = res.data.message
        }
      })
      .catch((res) => {
        this.error = res.response.data.message;
      })
    },
  },
  computed: {
    defaultCountryIso() {
      return this.countryOptionsIso?.length ? this.countryOptionsIso[0] : null
    }
  }
});
</script>